import React from 'react';

const About = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-sky-100 px-4 py-12">
      <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-3xl">
        <h1 className="text-4xl font-bold mb-6 text-center text-blue-600">About Us</h1>

        <p className="text-gray-700 text-lg mb-4">
          <strong>PScribes</strong> is a fast, accurate, and affordable transcription platform built for individuals and businesses alike.
          Whether you're converting audio memos, interviews, lectures, or podcasts into text — our goal is to make transcription effortless.
        </p>

        <p className="text-gray-700 text-lg mb-4">
          We believe high-quality tools shouldn't come at a high cost. That’s why we currently offer our service for free — to empower everyone, from content creators and students to professionals and researchers.
        </p>

        <p className="text-gray-700 text-lg mb-4">
          As we continue to grow, our mission is to offer flexible and cost-effective plans while maintaining top-notch performance and privacy. Your files are processed securely, and never stored longer than needed.
        </p>

        <p className="text-gray-700 text-lg mb-4">
          Created by <strong>SA Technologies Inc</strong>, we’re dedicated to making voice-to-text simple, fast, and accessible — with continued improvements based on your feedback.
        </p>

        <p className="text-gray-600 text-sm mt-6 text-center">
          Questions or suggestions? Email us at <a href="mailto:contact@pscribes.com" className="text-blue-600 hover:underline">contact@pscribes.com</a>
        </p>
      </div>
    </div>
  );
};

export default About;
